import  { useState, useEffect, ReactNode } from 'react'
import { useItemsStore } from '../../contexts/zustand/onboarding';

import Blocked from "./Blocked"
import { LoadingPage } from "../../components/LoadingPage"

import { toast } from "react-toastify"

type OnboardingsssProps = {
    children: ReactNode;
}

export default function ProtectRoutesOnboarding({children}: OnboardingsssProps) {

    const { checkPermissionOnboarding } = useItemsStore()

    const [loadingPage, setLoadingPage] = useState<boolean>(true)
    const [canRender, setCanRender] = useState<boolean>(false);

    useEffect(() => {
        const fetchData = async () => {
            try {

                const using_onboarding = checkPermissionOnboarding.using_onboarding

                if (!using_onboarding || !checkPermissionOnboarding.permission_onboarding) {
                    setCanRender(true);
                }
                
            } catch (error) {
                toast.error("Ops.. Tivemos um problema, por favor tente novamente mais tarde!", {
                    position: toast.POSITION.TOP_RIGHT
                });
            } finally {
                setLoadingPage(false);
            }
        };
    
        fetchData();
    }, [checkPermissionOnboarding]);
    

    if (loadingPage) {
        return <LoadingPage />;
    }

    if (canRender) {
        return <Blocked />;
    }

    return (<>{children}</>)

}


